import React, { useState, useEffect } from 'react';
import Header from '../common//header';
import Sidebar from '../common//navBar';
import CommonCard from '../common/commonCard';
import { Container, Row, Col, Spinner, Modal } from 'react-bootstrap';
import CustomTable from '../common/table';
import Footer from '../common//footer';
import { GetCompaniesService } from '../../Services/companyService';
import { getAccessToken, getInnuvaCompanies } from '../../Services/authorizationInnuvaService';
import MessagePopUp from '../common/messagePopUp';
import { useTranslation } from "react-i18next";

const Companies = () => {
  const [t] = useTranslation("companies")
  const [expanded, setExpanded] = useState(false);
  const [companiesData, setCompaniesData] = useState([]);

  const [companiesResponsible, setCompaniesResponsible] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bigLoading, setBigLoading] = useState();
  const [showModal, setShowModal] = useState(false);
  const [companiesFromInnuva, setCompaniesFromInnuva] = useState([]);
  const [companiesFailed, setCompaniesFailed] = useState([]);
  const [companiesSuccess, setCompaniesSuccess] = useState([]);
  const [showMessageError, setShowMessageError] = useState(false);
  const [showMessageSuccess, setShowMessageSuccess] = useState(false);
  const [apiData, setApiData] = useState(null);

  useEffect(() => {
    const fetchAccessToken = async () => {
      const storedCode = sessionStorage.getItem('code');
      const accessTokenStoraged = sessionStorage.getItem('accessToken');
      if (storedCode) {
        try {
          // ABRIR POP UP
          setBigLoading(true);
          const accessToken = await getAccessToken(storedCode);
          const companies = await getInnuvaCompanies(accessToken);
          setCompaniesFromInnuva(companies.data);
          setShowModal(true);
          setBigLoading(false);
          // Haz algo con la respuesta, como actualizar el estado o manejar la data
        } catch (error) {
          console.error('Error al obtener el token de acceso:', error);
          setBigLoading(false);
        }
      }

      if (accessTokenStoraged) {
        try {
          // ABRIR POP UP
          const companies = await getInnuvaCompanies(accessTokenStoraged);
          setCompaniesFromInnuva(companies.data);
          // Haz algo con la respuesta, como actualizar el estado o manejar la data
        } catch (error) {
          console.error('Error al obtener el token de acceso:', error);
        }
      }
    };

    fetchAccessToken();
  }, []);

  const handleShowMessageError = () => {
    setShowMessageError(true);
  };

  const handleShowMessageSuccess = () => {
    setShowMessageSuccess(true);
  };

  const handleButtonMessagePopUpErrorClick = () => {
    setShowMessageError(false);
    if (companiesSuccess.length > 0) {
      handleShowMessageSuccess();
    }

  };

  const handleButtonMessagePopUpSuccessClick = () => {
    setShowMessageSuccess(false);
    window.location.reload();
  };

  const formatCompanies = (companiesArray) => {
    // Transforma cada objeto de la matriz en una cadena de texto
    const companiesResult = companiesArray.map(companyItem =>
      `${companyItem.company.name} (${companyItem.company.nifCif})`
    );

    return companiesResult;

    // Actualiza el estado con el nuevo arreglo

  };


  const handleCompanyApiResponseFromInnuvaModal = async (companiesArray) => {
    if (companiesArray.length > 0) {
      const companiesArrayFailed = companiesArray.filter(item => typeof item.apiResponse !== 'object');

      const companiesArraySuccess = companiesArrayFailed.length === 0
        ? companiesArray
        : companiesArray.filter(companyItem => !companiesArrayFailed.some(companyFailed => companyFailed.company.nifCif === companyItem.company.nifCif));

      if (companiesArraySuccess.length > 0 && companiesArrayFailed.length === 0) {
        handleShowMessageSuccess();
        let companiesSuccessResult = await formatCompanies(companiesArraySuccess);
        setCompaniesSuccess(companiesSuccessResult);
      } else if (companiesArraySuccess.length > 0 && companiesArrayFailed.length > 0) {
        setApiData("Error NIF");
        let companiesFailedResult = await formatCompanies(companiesArrayFailed);
        setCompaniesFailed(companiesFailedResult);
        let companiesSuccessResult = await formatCompanies(companiesArraySuccess);
        setCompaniesSuccess(companiesSuccessResult);
        handleShowMessageError();
      } else {
        setApiData("Error NIF");
        let companiesFailedResult = await formatCompanies(companiesArrayFailed);
        setCompaniesFailed(companiesFailedResult);
        handleShowMessageError();
      }
    }
  };

  const columnHeaders = [
    `${t("companiesTable.nif")}`,
    `${t("companiesTable.company")}`,
    `${t("companiesTable.responsible")}`,
    `${t("companiesTable.functionsResponsible")}`,
    `${t("companiesTable.enabled")}`
  ];

  const enabled = [
    `${t("companiesTableFilters.enabled")}`,
    `${t("companiesTableFilters.disabled")}`
  ];

  const fieldsToShow = ['nifCif', 'name', 'responsibleFullName', 'functionResponsibleFullName', 'enabled'];

  const optionArrays = [[], [], companiesResponsible, enabled]

  async function fetchData() {
    setLoading(true)
    try {
      setCompaniesData([]);
      setCompaniesResponsible([]);
      const response = await GetCompaniesService(t);

      setCompaniesData(response);
      setLoading(false)

    } catch (error) {
      setLoading(false)
      console.error('Hubo un error al obtener los datos de las empresas', error);
    }
  }


  const handleReloadData = () => {

    fetchData();
  };

  useEffect(() => {


    fetchData();
  }, []);
  return (
    <div>
      <Header
        manual={'https://www.myreportin.com/descargas/manual-de-usuario-Myreportin.pdf'}
        reloadData={handleReloadData}
      />
      <Container fluid>
        <Row>
          <Col className='d-flex' style={{ paddingLeft: 0, paddingRight: 0, flex: `0 0 ${expanded ? '2%' : '4%'}` }}>
            <Sidebar expanded={expanded} setExpanded={setExpanded} selected={'Empresas'} />
          </Col>
          <Col
            className='custom-content-wrapper'
            style={{
              marginLeft: '0.5%',
              paddingRight: 0,
              flex: expanded ? '0 0 88%' : '0 0 93%',
            }}>
            <CommonCard title={`${t("card.title")}`} icon='FaBuilding'>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                <CustomTable
                  key={loading}
                  columnHeaders={columnHeaders}
                  fieldsToShow={fieldsToShow}
                  data={companiesData}
                  showNewButton
                  showImportButton
                  simulateButton
                  NewButtonRoute={"/create-company"}
                  navigateTo={'/edit-company'}
                  optionArrays={optionArrays}
                  dataType={'companies'}
                  loading={loading}
                  doubleButton
                  showModalFromCompany={showModal}
                  innuvaCompaniesFromCompany={companiesFromInnuva}
                  companyApiResponseFromInnuvaModal={handleCompanyApiResponseFromInnuvaModal}
                />

              </div>
              <Modal
                show={bigLoading}
                //onHide={handleClose}
                backdrop="static"
                className={`notification ${bigLoading ? 'notification-modal-show' : ''}`}
              >
                <div className="public-card-loading-container loading-centered">
                  <div className="public-card-loading-row ">
                    <div className="public-card-loading-popup custom-shadow-bold rounded-border-px">
                      <Spinner animation="border" className="spinner-bigger" />
                    </div>
                  </div>
                </div>
              </Modal>
              <MessagePopUp
                show={showMessageError}
                handleClose={() => setShowMessageError(false)}
                title={apiData === "Error NIF" ? `${t("companiesPopup.nifDualErrorTitle")}` : `${t("companiesPopup.mailErrorTitle")}`}
                textBody={
                  apiData === "Error NIF" ? (
                    <>
                      <p>{companiesFailed.length > 1 ?
                        `${t("companiesPopup.nifDualErrorText")}: ` :
                        `${t("companiesPopup.nifErrorText")}: `} </p>
                      <ul className='scroll-list'>
                        {companiesFailed.map((company, index) => (
                          <li key={index}>{company}</li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    `${t("companiesPopup.mailErrorText")}`
                  )
                }
                buttonText={t("companiesPopup.acceptButton")}
                onClickButton={handleButtonMessagePopUpErrorClick}
              />
              <MessagePopUp
                show={showMessageSuccess}
                handleClose={() => setShowMessageSuccess(false)}
                title={companiesSuccess.length > 1 ? `${t("companiesPopup.companiesSuccessText")}` : `${t("companiesPopup.companySuccessText")}`}
                textBody={
                  <>
                    <ul className='scroll-list'>
                      {companiesSuccess.map((company, index) => (
                        <li key={index}>{company}</li>
                      ))}
                    </ul>
                  </>}
                buttonText={t("companiesPopup.acceptButton")}
                onClickButton={handleButtonMessagePopUpSuccessClick}
              />
            </CommonCard>
            <Footer />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Companies;






